<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <b-tabs
      v-if="user && user.is_superuser"
      content-class="mt-3"
      class="custom-tabs mt-3"
    >
      <!-- Tab de Configuración -->
      <b-tab :title="$t('toolbar.adminUsers.configuration')" active>
        <template #title>
          <b-icon-gear-fill class="mr-2"></b-icon-gear-fill>
          {{ $t("toolbar.adminUsers.configuration") }}
        </template>
        <InstitutionCard :allows_crud="allows_crud"></InstitutionCard>
      </b-tab>

      <!-- Tab de Logs -->
      <b-tab :title="$t('toolbar.adminUsers.logs')">
        <template #title>
          <b-icon-file-text class="mr-2"></b-icon-file-text>
          {{ $t("toolbar.adminUsers.logs") }}
        </template>
        <InstitutionLogsView></InstitutionLogsView>
      </b-tab>
      <!-- Tab de Carga masiva -->
      <b-tab :title="$t('toolbar.adminUsers.bulkLoading')">
        <template #title>
          <b-icon-folder-plus class="mr-2"></b-icon-folder-plus>
          {{ $t("toolbar.adminUsers.bulkLoading") }}
        </template>
        <InstitutionBulkLoading
          :allows_crud="allows_crud"
        ></InstitutionBulkLoading>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "AdminInstitutionView",
  components: {
    InstitutionCard: () => import("./InstitutionCard"),
    InstitutionLogsView: () => import("./InstitutionLogsView"),
    InstitutionBulkLoading: () => import("./InstitutionBulkLoading"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    allows_crud() {
      const has_permission = this.$hasPermissions("teaching.change_access");
      if (has_permission && this.user && this.user.is_superuser)
        return has_permission;
      else return false;
    },
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        { text: this.$t("reusable.toolbar.institution") },
      ];
    },
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped>
.custom-tabs >>> .nav-tabs {
  border-bottom: 2px solid #dee2e6;
}

.custom-tabs >>> .nav-link {
  /* color: #495057; */
  border: none;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}

.custom-tabs >>> .nav-link:hover {
  color: var(--kl-color-primary);
  border-bottom-color: rgba(0, 110, 200);
}

.custom-tabs >>> .nav-link.active {
  color: var(--kl-color-primary);
  background-color: transparent;
  border-bottom-color: var(--kl-color-primary);
  /* font-weight: 600; */
}
</style>